var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"map-preview",staticStyle:{"width":"100%","height":"100%","min-height":"300px","min-width":"300px"},attrs:{"id":`map-preview-${_vm.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }